import { useEffect } from "react";
import { SITE_ORIGIN, useSeoDispatch } from "@/components/Seo";

// SEO hook — every page calls this with its title/description/keywords/jsonLd.
// Props are forwarded to the central <SeoProvider> (src/components/Seo.jsx),
// which writes them to the document head via react-helmet-async.
//
// Canonical handling: `canonical` may be a path ("/cities/winnipeg") or a full
// URL — the origin is always normalised to the production domain. Pages that
// omit `canonical` automatically get a self-referencing canonical derived
// from the current path, so every route is canonicalised.
export default function useSEO({ title, description, keywords, canonical, jsonLd }) {
  const setSeo = useSeoDispatch();

  // Serialise array/object inputs so effect deps stay stable across renders.
  const kwStr = Array.isArray(keywords) ? keywords.join(", ") : keywords || "";
  const ldStr = jsonLd ? JSON.stringify(jsonLd) : "";
  const path = canonical
    ? canonical.replace(/^https?:\/\/[^/]+/, "") || "/"
    : typeof window !== "undefined"
    ? window.location.pathname
    : "/";
  const canonicalUrl = SITE_ORIGIN + (path === "/" ? "" : path);

  useEffect(() => {
    setSeo({
      title,
      description,
      keywords: kwStr,
      canonical: canonicalUrl,
      jsonLd: ldStr ? JSON.parse(ldStr) : undefined,
    });
  }, [title, description, kwStr, canonicalUrl, ldStr, setSeo]);
}
